module.exports = __webpack_public_path__ + "static/img/image_solutions_precision_02.2e1143d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_precision_02.png
// module id = +fH5
// module chunks = 10